// import "../static/font.css"
// import "../static/style.css"

import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store/store"
import axios from 'axios'
// import Meta from 'vue-meta'
import MetaInfo from 'vue-meta-info'

// if (!global._babelPolyfill) {
//   require('babel-polyfill');
// }

import "../static/bootstrap.min.css"
import animated from "animate.css"

import 'babel-polyfill'
require('es6-promise').polyfill()

import {
  Popover,
  CollapseTransition
} from 'element-ui'
import VueAwesomeSwiper from 'vue-awesome-swiper'
// 按需引入vant组件
import {
  Toast,
  Button,
  Pagination,
  Empty,
  Popup,
  Loading
} from 'vant'
import 'vant/lib/index.css'


// import "../static/common.min.js"

import "../node_modules/swiper/dist/css/swiper.min.css";
import 'element-ui/lib/theme-chalk/index.css'


//中英文切换
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
router.beforeEach((to, from, next) => {
  if ((to.query.lang !== 'zh' && to.query.lang !== 'en')) {
    if (from.query.lang === 'zh' || from.query.lang === 'en') {
      to.query.lang = from.query.lang
    } else {
      to.query.lang = 'en'
    }
    next({
      path: to.path,
      name: to.name,
      query: to.query,
      params: to.params,
    })
  } else {
    next()
  }
})


const i18n = new VueI18n({
  locale: store.state.locale, //从localStorage里获取用户中英文选择，没有则默认中文
  messages: {
    'zh': require('./untils/language/zh'),
    'en': require('./untils/language/en')
  }
})

import "./untils/validate"

import VueLazyLoad from 'vue-lazyload'
Vue.use(VueAwesomeSwiper)

var userAgent = window.navigator.userAgent
if (userAgent.indexOf('NET') != -1) {
  //ie浏览器不兼容懒加载组件处理
  Vue.directive('lazy', function (el, binding) {
    el.src = binding.value
  })
} else {
  Vue.use(VueLazyLoad, {
    preLoad: 1.3,
    error: require('./images/loading.svg'),
    loading: require('./images/loading.svg'),
    attempt: 1
  })
}

Vue.use(animated)
Vue.use(Popover)
Vue.component(CollapseTransition.name, CollapseTransition)

// 使用vue-meta
// Vue.use(Meta)

Vue.use(MetaInfo)

// 使用vant组件
Vue.use(Toast)
  .use(Button)
  .use(Pagination)
  .use(Empty)
  .use(Popup)
  .use(Loading)
Vue.config.productionTip = false;

store.state.baseURL = axios.defaults.baseURL;

Vue.filter('NumFormat', function (value) {
  if (!value) return '0';
  var intPart = Number(value).toFixed(0); //获取整数部分
  var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断
  return intPartFormat;
})

Vue.filter('NumFormatIcon', function (value) {
  if (!value) return '0';
  var intPart = Number(value).toFixed(0); //获取整数部分
  var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断
  return '$' + intPartFormat;
})

Vue.filter('NumFormatPrice', function (value) {
  if (!value) return '0'
  let intPart = Number(value).toFixed(2) //获取整数部分
  let intPartFormat = intPart
  let strTemp = intPart.toString()
  let strs = intPart.split('.')
  let str = strs[1]
  if (str == '00') {
    intPartFormat = strs[0]
  } else if (str.split('')[1] == '0') {
    intPartFormat = strTemp.substring(0, strTemp.length - 1)
  }
  intPartFormat = intPartFormat.replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,') //将整数部分逢三一断
  return intPartFormat
})

Vue.directive('preventReClick', {
  inserted(el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        setTimeout(() => {
          el.disabled = false
        }, binding.value || 2000)
      }
    })
  }
})

import './untils/scroll-to'

new Vue({
  el: '#app',
  router,
  i18n, //把 i18n 挂载到 vue 根实例上
  store,
  components: {
    App
  },
  template: '<App/>',
  mounted() {
    setTimeout(() => {
      document.dispatchEvent(new Event('render-event'))
    }, 200)
  }
})



// WEBPACK FOOTER //
// ./src/main.js